import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { GlobalFooterModule } from '@delon/abc/global-footer';
import { HeaderI18nComponent } from '../../main-layout/main-layout/widgets/i18n.component'
import { NzIconModule } from 'ng-zorro-antd/icon';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports:[RouterOutlet,NzLayoutModule,GlobalFooterModule,HeaderI18nComponent,NzIconModule],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss'
})
export class AuthLayoutComponent {
  currentVersion=environment.version;
    constructor() {}
}
